"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
function createLogger(namespace) {
    return new skynet_store_utilities_1.Logger('idm-frontend-shared', namespace);
}
exports.createLogger = createLogger;
function buildMultilingualStringFromObject(obj) {
    var builder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    Object.keys(obj).forEach(function (key) {
        if (obj.hasOwnProperty(key)) {
            builder.withValueForLanguage(+key, obj[key]);
        }
    });
    return builder.build();
}
exports.buildMultilingualStringFromObject = buildMultilingualStringFromObject;
function createObjectFromMultilingualString(text) {
    if (text) {
        var map = text.toMap();
        var obj_1 = {};
        Array.from(map).forEach(function (entry) {
            obj_1[entry[0]] = entry[1];
        });
        return obj_1;
    }
    return text;
}
exports.createObjectFromMultilingualString = createObjectFromMultilingualString;
//# sourceMappingURL=utilities.js.map